import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadTemplate () {
    const api = getApiClient(this.$store)
    const templateId = this.$route.params.id

    api.get(`message_templates/${templateId}`)
      .then(result => {
        this.template = result.data
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.template.id ? 'patch' : 'post'
    const options = {}

    let endpoint = 'message_templates'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.template['@id']
    }

    api[method](endpoint, this.template, options)
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Template salvo com sucesso')
        this.$router.push({
          name: 'MessageTemplates',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar template')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
